/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { IconButton } from '@coursera/cds-core';

import { CAROUSEL_SLIDE_HEIGHT } from 'bundles/front-page/components/modules/hero-banner/HeroCarouselSlide';
import TrackedDiv from 'bundles/page/components/TrackedDiv';

import _t from 'i18n!nls/front-page';

type Control = { isNext?: boolean };

type Props = Control & {
  currentRef: { current: number };
};

const styles = {
  button: css`
    border-radius: 100%;
    display: inline-flex !important;
    vertical-align: middle;
    height: ${CAROUSEL_SLIDE_HEIGHT}px;
    top: calc(100% - ${CAROUSEL_SLIDE_HEIGHT / 2}px);
  `,
  buttonWrapper: css`
    display: inline-flex;
  `,
};

const HeroCarouselControlButton = ({ currentRef, isNext, ...props }: Props) => {
  const ariaLabel = isNext ? _t('Move Carousel Right') : _t('Move Carousel Left');
  const trackingName = isNext ? 'carousel_right_button' : 'carousel_left_button';

  return (
    <TrackedDiv
      {...props}
      trackingName={trackingName}
      trackingData={{ currentPage: currentRef.current }}
      id={`front_page_${trackingName}`}
      css={styles.buttonWrapper}
      tabIndex={-1}
    >
      <IconButton
        css={styles.button}
        intent={isNext ? 'next' : 'previous'}
        variant="secondary"
        aria-label={ariaLabel}
        hideTooltip
      />
    </TrackedDiv>
  );
};

export default HeroCarouselControlButton;
